<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <h1 class="title-default">Kanban de ordem de serviço</h1>
    <p class="welcome-message">
      <button mat-icon-button type="button" aria-label="Voltar" (click)="voltar()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      Configure as etapas, o fluxo de movimentação e as permissões por perfil das ordens de serviço.
    </p>

    @if (isLoading) {
      <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
      <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
      <app-loading-box height="30" width="260" marginTop="36"></app-loading-box>
      <app-loading-box height="18" width="55%" marginTop="16"></app-loading-box>
      @for (item of skeletonCards; track $index) {
        <app-loading-box height="74" width="100%" marginTop="12"></app-loading-box>
      }
    } @else {
      <div class="painel ajuda">
        <button
          type="button"
          class="painel-head w-100 d-flex align-items-center justify-content-between flex-wrap"
          (click)="mostrarAjuda = !mostrarAjuda">
          <span class="painel-titulo d-flex align-items-center gap-2 fw-semibold text-start">
            <mat-icon class="material-symbols-outlined ic-help">help</mat-icon> Como esta tela funciona
          </span>
          <span class="painel-acao d-inline-flex align-items-center flex-shrink-0 text-nowrap fw-semibold">
            {{ mostrarAjuda ? 'Ocultar ajuda' : 'Mostrar ajuda' }}
            <mat-icon>{{ mostrarAjuda ? 'expand_less' : 'expand_more' }}</mat-icon>
          </span>
        </button>
        @if (mostrarAjuda) {
          <div class="painel-body">
            <p class="m-0">
              O quadro de ordens de serviço tem um único processo. Nele você cria as etapas, define para quais
              outras etapas o card pode avançar e quem pode executar cada movimentação.
            </p>
            <div class="legenda d-flex flex-wrap gap-3 mt-2">
              <span
                ><mat-icon class="material-symbols-outlined">play_circle</mat-icon> Inicial — onde o card
                nasce</span
              >
              <span class="vermelho"
                ><mat-icon class="material-symbols-outlined">flag</mat-icon> Final — encerra o card</span
              >
              <span class="vermelho"
                ><mat-icon class="material-symbols-outlined">bolt</mat-icon> Automação — etapa usada como
                gatilho</span
              >
              <span class="amarelo"
                ><mat-icon class="material-symbols-outlined">warning</mat-icon> Validação — etapa
                inalcançável, sem saída ou sem perfil</span
              >
            </div>
          </div>
        }
      </div>

      @if (avisos.length) {
        <div class="painel validacao warning">
          <button
            type="button"
            class="painel-head w-100 d-flex align-items-center justify-content-between flex-wrap"
            (click)="avisosAbertos = !avisosAbertos">
            <span class="painel-titulo d-flex align-items-center gap-2 fw-semibold text-start">
              <mat-icon class="material-symbols-outlined ic-warn">warning</mat-icon>
              {{ avisos.length }} {{ avisos.length === 1 ? 'aviso de fluxo' : 'avisos de fluxo' }}
            </span>
            <span class="painel-acao d-inline-flex align-items-center flex-shrink-0 text-nowrap fw-semibold">
              {{ avisosAbertos ? 'minimizar' : 'exibir' }}
              <mat-icon>{{ avisosAbertos ? 'expand_less' : 'expand_more' }}</mat-icon>
            </span>
          </button>
          @if (avisosAbertos) {
            <div class="painel-body">
              @for (a of avisos; track $index) {
                <button
                  type="button"
                  class="aviso-item w-100 d-flex align-items-center gap-2 text-start"
                  [class.clicavel]="a.idEtapaKanban"
                  (click)="focarAviso(a)">
                  <mat-icon class="material-symbols-outlined ic-warn">error</mat-icon>
                  <span class="flex-grow-1">{{ a.mensagem }}</span>
                  @if (a.idEtapaKanban) {
                    <mat-icon class="material-symbols-outlined chev">chevron_right</mat-icon>
                  }
                </button>
              }
            </div>
          }
        </div>
      } @else if (!isFalhaConfig) {
        <div class="painel validacao ok">
          <span class="painel-titulo d-flex align-items-center gap-2 fw-semibold text-start">
            <mat-icon class="material-symbols-outlined ic-ok">verified</mat-icon>
            Fluxo consistente — todas as etapas têm entrada, saída e perfis definidos.
          </span>
        </div>
      }

      <section class="fluxo-section">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">route</mat-icon>
          <span>Etapas da ordem de serviço</span>
          <div class="section-title-actions ms-auto">
            <span
              [matTooltip]="
                isFalhaConfig ? 'As etapas não foram carregadas. Recarregue a tela para criar uma etapa.' : ''
              ">
              <button
                mat-flat-button
                type="button"
                class="btn-primary"
                [disabled]="isFalhaConfig"
                (click)="novaEtapa()">
                <mat-icon class="material-symbols-outlined">add</mat-icon> Nova etapa
              </button>
            </span>
          </div>
        </div>
        <p class="section-sub-title">
          Etapas pelas quais as ordens de serviço passam, na ordem do board. As etapas padrão têm posição fixa
          — apenas etapas criadas por você podem ser reordenadas.
        </p>

        <div
          class="etapas-list"
          cdkDropList
          [cdkDropListSortPredicate]="podeSoltarNaPosicao"
          (cdkDropListDropped)="drop($event)">
          @for (s of fluxo; track s.idEtapaKanban; let i = $index) {
            <div
              class="etapa-card d-flex align-items-center gap-3"
              cdkDrag
              [cdkDragDisabled]="s.isFixo"
              (cdkDragStarted)="iniciarArraste()"
              [attr.id]="'etapa-kanban-' + s.idEtapaKanban"
              [style.--k-dot]="cor(s.idKanbanCor)?.corPrincipal"
              [style.--k-dot-dark]="cor(s.idKanbanCor)?.corPrincipalDark"
              [style.--k-bg]="cor(s.idKanbanCor)?.corFundo"
              [style.--k-bg-dark]="cor(s.idKanbanCor)?.corFundoDark"
              [style.--k-fg]="cor(s.idKanbanCor)?.corConteudo"
              [style.--k-fg-dark]="cor(s.idKanbanCor)?.corConteudoDark">
              <div class="etapa-card-placeholder" *cdkDragPlaceholder></div>
              <span
                class="etapa-handle d-inline-flex align-items-center justify-content-center"
                [class.etapa-handle--fixo]="s.isFixo"
                cdkDragHandle
                [matTooltip]="s.isFixo ? 'Etapa padrão (posição fixa).' : 'Arraste para reordenar.'">
                <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
              </span>
              <ng-container
                *ngTemplateOutlet="cardEtapa; context: { $implicit: s, ordem: i + 1, especial: false }">
              </ng-container>
            </div>
          }
        </div>
      </section>

      @if (especiais.length) {
        <section class="fluxo-section">
          <div class="sub-section-title">
            <mat-icon class="material-symbols-outlined">auto_awesome</mat-icon>
            <span>Etapas especiais</span>
          </div>
          <p class="section-sub-title">
            Estados fora do fluxo linear. Recebem cards de qualquer etapa permitida.
          </p>
          <div class="etapas-list">
            @for (s of especiais; track s.idEtapaKanban) {
              <div
                class="etapa-card d-flex align-items-center gap-3"
                [attr.id]="'etapa-kanban-' + s.idEtapaKanban"
                [style.--k-dot]="cor(s.idKanbanCor)?.corPrincipal"
                [style.--k-dot-dark]="cor(s.idKanbanCor)?.corPrincipalDark"
                [style.--k-bg]="cor(s.idKanbanCor)?.corFundo"
                [style.--k-bg-dark]="cor(s.idKanbanCor)?.corFundoDark"
                [style.--k-fg]="cor(s.idKanbanCor)?.corConteudo"
                [style.--k-fg-dark]="cor(s.idKanbanCor)?.corConteudoDark">
                <span
                  class="etapa-handle etapa-handle--fixo d-inline-flex align-items-center justify-content-center"
                  matTooltip="Etapa especial — fora do fluxo linear, sem reordenação.">
                  <mat-icon class="material-symbols-outlined">lock</mat-icon>
                </span>
                <ng-container
                  *ngTemplateOutlet="cardEtapa; context: { $implicit: s, ordem: null, especial: true }">
                </ng-container>
              </div>
            }
          </div>
        </section>
      }
    }
  </div>
</div>

<ng-template #cardEtapa let-s let-ordem="ordem" let-especial="especial">
  <span class="etapa-numero text-center fw-semibold">{{ ordem }}</span>

  <span class="etapa-icone d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3">
    <mat-icon class="material-symbols-outlined">{{ iconeNome(s.idKanbanIcone) }}</mat-icon>
  </span>

  <div class="etapa-info flex-grow-1">
    <div class="d-flex align-items-center flex-wrap gap-2">
      <span class="etapa-nome text-bold">{{ s.nome }}</span>
      @if (s.isInicial) {
        <span class="status-badge badge-cinza etapa-badge fw-semibold">
          <mat-icon class="material-symbols-outlined">play_circle</mat-icon> Inicial
        </span>
      }
      @if (s.isFinal) {
        <span class="status-badge badge-cinza etapa-badge fw-semibold">
          <mat-icon class="material-symbols-outlined">flag</mat-icon> Final
        </span>
      }
      @if (automacoesDaEtapa(s).length) {
        <span class="status-badge badge-cinza etapa-badge fw-semibold" [matTooltip]="tooltipAutomacoes(s)">
          <mat-icon class="material-symbols-outlined">bolt</mat-icon> Automação
        </span>
      }
      @if (especial) {
        <span
          class="status-badge badge-cinza etapa-badge fw-semibold"
          matTooltip="Estado fora do fluxo linear: recebe cards das etapas que a tiverem como destino.">
          <mat-icon class="material-symbols-outlined">auto_awesome</mat-icon> Especial
        </span>
      }
      @if (s.isMotivoObrigatorio) {
        <span class="status-badge badge-cinza etapa-badge fw-semibold" [matTooltip]="tooltipMotivo(s)">
          <mat-icon class="material-symbols-outlined">edit_note</mat-icon> Exige motivo
        </span>
      }
      @if (s.idsCampoAdicional.length) {
        <span class="status-badge badge-cinza etapa-badge fw-semibold" [matTooltip]="tooltipCampos(s)">
          <mat-icon class="material-symbols-outlined">fact_check</mat-icon> {{ labelCampos(s) }}
        </span>
      }
    </div>
    @if (s.descricao) {
      <p class="etapa-descricao mt-1 mb-0">{{ s.descricao }}</p>
    }
  </div>

  <div class="d-flex align-items-center flex-shrink-0 gap-4">
    <div class="etapa-stat d-flex flex-column align-items-center" [matTooltip]="tooltipVisibilidade(s)">
      <span class="etapa-stat-num d-inline-flex align-items-center gap-1 fs-6 fw-semibold">
        <mat-icon class="material-symbols-outlined">visibility</mat-icon
        >{{ s.idsPerfilVisibilidade.length || 'Todos' }}
      </span>
      <span class="etapa-stat-label">Perfis</span>
    </div>
    <div class="etapa-stat d-flex flex-column align-items-center">
      <span class="etapa-stat-num d-inline-flex align-items-center gap-1 fs-6 fw-semibold">
        <mat-icon class="material-symbols-outlined">trending_flat</mat-icon
        >{{ especial ? '-' : s.movimentacoes.length }}
      </span>
      <span class="etapa-stat-label">Destinos</span>
    </div>
  </div>

  <div class="etapa-status d-flex flex-column align-items-center justify-content-center flex-shrink-0">
    @if (s.isFixo) {
      <span
        class="etapa-fixo d-inline-flex align-items-center gap-1"
        matTooltip="Etapa fixa do sistema: não pode ser desativada.">
        <mat-icon class="material-symbols-outlined">lock</mat-icon> Fixa
      </span>
    } @else {
      <span [matTooltip]="s.isInicial ? 'A etapa inicial não pode ser desativada.' : ''">
        <mat-slide-toggle
          class="app-toggle-compact d-flex align-items-center mb-0"
          color="primary"
          [checked]="s.isAtivo"
          [disabled]="s.isInicial || idEtapaProcessando === s.idEtapaKanban"
          (change)="toggleAtivo(s, $event)"
          [attr.aria-label]="s.isAtivo ? 'Etapa ativa' : 'Etapa inativa'"></mat-slide-toggle>
      </span>
      <span class="etapa-status-label">{{ s.isAtivo ? 'Ativa' : 'Inativa' }}</span>
    }
  </div>

  <div class="etapa-acoes d-flex align-items-center flex-shrink-0">
    <button
      mat-icon-button
      type="button"
      class="btn-spinner"
      [matMenuTriggerFor]="menuEtapa"
      matTooltip="Mais opções"
      [class.btn-loading]="idEtapaProcessando === s.idEtapaKanban"
      [disabled]="idEtapaProcessando === s.idEtapaKanban"
      [attr.aria-label]="idEtapaProcessando === s.idEtapaKanban ? 'Processando' : 'Mais opções'">
      <mat-icon class="material-symbols-outlined">more_horiz</mat-icon>
      @if (idEtapaProcessando === s.idEtapaKanban) {
        <mat-spinner diameter="18"></mat-spinner>
      }
    </button>
    <mat-menu #menuEtapa="matMenu">
      <button mat-menu-item type="button" (click)="editar(s)">
        <mat-icon class="material-symbols-outlined">edit</mat-icon><span>Editar</span>
      </button>

      @if (!s.isFixo) {
        <button mat-menu-item type="button" (click)="excluir(s)">
          <mat-icon class="material-symbols-outlined">delete</mat-icon><span>Excluir</span>
        </button>
      }
    </mat-menu>
  </div>
</ng-template>
